import * as client from "_graphql-types";
import * as types from "./types";
import uuid from "frontend/src/utils/uuid";

type Sdk = ReturnType<typeof client.getSdk>;

const create = async (
  sdk: Sdk,
  param: types.CreateParams<{ queueId: string }>
) => {
  console.log("create:", param);

  if (!param.data.queueId) {
    throw new Error("No queueId to process");
  }
  await sdk.processDocumentQueue({ queueId: param.data.queueId });

  return { data: { id: param.data.queueId } };
};

export const documentQueueProcessing = types.dataProvider({
  create,
});
